export const eventConstants = {
  OPEN_MODAL: "OPEN_MODAL",
  ADMIN_EVENT_LIST: "ADMIN_EVENT_LIST",
  ALL_EVENT: "ALL_EVENT",
  ADD_EVENT: "ADD_EVENT",
  VIEW_MODAL: "VIEW_MODAL",
  DELETE_EVENT: "DELETE_EVENT",
  EVENT_DATA_BY_ID: "EVENT_DATA_BY_ID",
  EVENT_DATA_BY_ID_WITH_DOCS: "EVENT_DATA_BY_ID_WITH_DOCS",
  UPDATE_EVENT: "UPDATE_EVENT",
  ADMIN_EVENT_PARTICIPANTS_LIST: "ADMIN_EVENT_PARTICIPANTS_LIST",
  SEARCH_PARTICIPANTS: "SEARCH_PARTICIPANTS",
  ADD_EVENT_PARTICIPANTS: "ADD_EVENT_PARTICIPANTS",
  EVENT_ID: "eventId",
  MODE: "mode",
  PUBLIC: "Public",
  PRIVATE: "Private",
  ALL: "All",
  LIST_PUBLIC_EVENTS: "LIST_PUBLIC_EVENTS",
  MY_EVENTS_LIST: "MY_EVENTS_LIST",
  VALIDATE_PARTICIPANTS: "VALIDATE_PARTICIPANTS",
  VALIDATE_PARTICIPANTS_TOFALSE: "VALIDATE_PARTICIPANTS_TOFALSE",
  RESET_PARTICIPANT_DETAILS: "RESET_PARTICIPANT_DETAILS",
  DOWNLOAD_PARTICIPANT_DETAILS: "DOWNLOAD_PARTICIPANT_DETAILS",
  CANCEL_PUBLIC_EVENT_REGISTRATION: "CANCEL_PUBLIC_EVENT_REGISTRATION",
  CANCEL_PUBLIC_EVENT_REGISTRATION_BY_ADMIN:
    "CANCEL_PUBLIC_EVENT_REGISTRATION_BY_ADMIN",
  CANCEL_PRIVATE_EVENT_REGISTRATION: "CANCEL_PRIVATE_EVENT_REGISTRATION",
  RESET_EVENT_DATA_BY_ID: "RESET_EVENT_DATA_BY_ID",
  EVENT_TOTAL_PAYMENT_BY_ID_DATA: "EVENT_TOTAL_PAYMENT_BY_ID_DATA"
};

export const EVENT_STATUS = {
  Published: 0,
  Unpublished: 1,
  Draft: 2,
  Expired: 3,
};


export const eventStatusEnum = {
  PUBLISHED: 0,
  UNPUBLISHED: 1,
  DRAFT: 2,
  EXPIRED: 3,
};